import { API } from '@config';
import { HrPetitionsTable } from '@src/types/HrPetitions';

export const getHrPetitions = async () => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${API}/api/hr-petitions?populate=File&sort=id%3Adesc`, options);
  const data: HrPetitionsTable = await response.json();

  return data;
};
